import React, { useState, useRef } from 'react';
import './SenPost.css';
import axios from 'axios';

function SendPost() {
  const h2Ref = useRef();
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");

  const submitHandler = (e) => {
    e.preventDefault(); // Fixed typo
    axios.post("https://jsonplaceholder.typicode.com/posts", { title, body }) // Fixed incorrect data format
      .then(() => { 
        h2Ref.current.innerHTML = "Success"; // Fixed innerHTML issue
      })
      .catch(err => console.log(err));
  };

  return (
    <div className='Send'>
      <h2 ref={h2Ref}>Send post</h2>
      <form onSubmit={submitHandler}>
        <input
          type='text'
          name='title'
          value={title}
          placeholder='Enter title'
          required // Fixed required attribute
          onChange={(e) => setTitle(e.target.value)} 
        />
        <textarea
          name='body'
          placeholder='Enter body text'
          required // Fixed required attribute
          value={body}
          onChange={(e) => setBody(e.target.value)} 
        />
        <button type='submit'>Send Post</button>
      </form>
    </div>
  );
}

export default SendPost;